import ReactDOM from 'react-dom/client';
import App from './components/App';

document.querySelectorAll('.jobs-app').forEach((el) => {
	const root = ReactDOM.createRoot(el);
	root.render(
		<App
			restUrl={el.getAttribute('data-rest-url')}
			showFilter={!!el.getAttribute('data-filter')}
			showFaces={!!el.getAttribute('data-faces')}
			filteredScope={!!el.getAttribute('data-filtered-scope')}
		/>,
	);
});
